




























import { Component,	Vue, Prop } from 'vue-property-decorator';

import { bus } from '@/main'
import GlobalMixins from '@/mixins'

@Component
export default class InfoButton extends GlobalMixins {
	@Prop() screen?: string
	@Prop() alt?: boolean
	@Prop() icon?: boolean

	toggleInfo(): void {
		if (this.alt) {
			bus.$emit('toggleInfo', this.screen)
		} else {
			bus.$emit('toggleInfo')
		}
	}

	get infoButton(): false | string {
		const screenToMatch = this.screen ? this.screen : this.$route.name
		const currentInfoScreen = this.infoScreens.find((infoScreen: any) => 
			infoScreen.screen === screenToMatch || infoScreen.screen === this.trimmedRouteName
		)
		if (currentInfoScreen) {
			return currentInfoScreen.title
		} else {
			return false
		}
	}

	get trimmedRouteName(): string {
		const routeName = this.$route.name!
		const lastIndex = routeName.lastIndexOf('-')
		if(lastIndex === -1) {
			return routeName
		}
		return routeName.slice(0, lastIndex)
	}

	get infoScreens(): any {
		return this.$store.getters.infoScreens
	}
}
